import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import React, { useState, useRef, useCallback } from "react";
import "../Assets/Css/Table.css";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { axiosConfig } from "../axiosAPI";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { useAuth } from "../AuthProvider";
import PermissionGate from "../components/PermissionGate";
import GlobalDataTable from "../components/GlobalDataTable";

function rowMatchesKeyword(row, keyword) {
  const k = keyword.toLowerCase();
  return [row.linkUrl, row.dateFrom, row.dateTo, row.uuid, row.imagePath, row.dateCreated]
    .some((x) => String(x ?? "").toLowerCase().includes(k));
}

function Adv() {
  const auth = useAuth();
  const adsTableRef = useRef(null);
  const adsListCacheRef = useRef(null);

  const invalidateAdsCacheAndReload = () => {
    adsListCacheRef.current = null;
    adsTableRef.current?.reload();
  };

  const fetchAdsPage = useCallback(
    async ({ pageNo, rowCount, keyword }) => {
      const headers = {
        Authorization: "Bearer " + auth.token,
        "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
      };
      const base = `${process.env.REACT_APP_BASE_URL}/ads`;

      try {
        let all;
        if (adsListCacheRef.current) {
          all = adsListCacheRef.current;
        } else {
          const response = await axiosConfig.get(base, { headers });
          all = Array.isArray(response.data.data) ? response.data.data : [];
          adsListCacheRef.current = all;
        }

        const working = keyword ? all.filter((row) => rowMatchesKeyword(row, keyword)) : all;
        const start = (pageNo - 1) * rowCount;
        const slice = working.slice(start, start + rowCount);
        return { result: slice, totalCount: working.length };
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        return { result: [], totalCount: 0 };
      }
    },
    [auth.token]
  );
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const headerElement2 = (
    <div className="d-flex align-items-center justify-content-between gap-2">
      <span className="font-bold white-space-nowrap">Edit Advertisements</span>
    </div>
  );
  const headerElement = (
    <div className="inline-flex align-items-center justify-content-center gap-2">
      <span className="font-bold white-space-nowrap">Add Advertisements</span>
    </div>
  );
  const footerContent = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => setVisible(false)}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => {
          handleSubmit();
          setVisible(false);
        }}
        className="save"
        autoFocus
      />
    </div>
  );
  const footerContent2 = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => setVisible2(false)}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => {
          editUser();
          setVisible2(false);
        }}
        className="save"
        autoFocus
      />
    </div>
  );

  const [formData, setFormData] = useState({
    uuid: "",
    dateFrom: "",
    dateTo: "",
    linkUrl: "",
    ImageFile: [],
  });

  const handleFileChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    const submitData = {
      ...formData,
      dateFrom: formData.dateFrom ? new Date(formData.dateFrom).toISOString() : "",
      dateTo: formData.dateTo ? new Date(formData.dateTo).toISOString() : "",
    };
    
    const response = await axiosConfig
      .post(`${process.env.REACT_APP_BASE_URL}/ads`, submitData, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "Content-Type": "multipart/form-data",
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      })
      .then((res) => {
        invalidateAdsCacheAndReload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const deleteUser = async (uuid) => {
    // wait for 1 second before deleting
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const response = await axiosConfig
      .delete(`${process.env.REACT_APP_BASE_URL}/ads/${uuid}`, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "Content-Type": "multipart/form-data",
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      })
      .then((res) => {
        invalidateAdsCacheAndReload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const editUser = async () => {
    const submitData = {
      ...formData,
      dateFrom: formData.dateFrom ? new Date(formData.dateFrom).toISOString() : "",
      dateTo: formData.dateTo ? new Date(formData.dateTo).toISOString() : "",
    };
    
    const response = await axiosConfig
      .put(`${process.env.REACT_APP_BASE_URL}/ads/${formData.uuid}`, submitData, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "Content-Type": "multipart/form-data",
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      })
      .then((res) => {
        invalidateAdsCacheAndReload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const statusAction = (rowData) => {
    return (
      <>
        <div className="action-table">
          <PermissionGate permission="p_ad0003">
            <a
              className="edit"
              onClick={(e) => {
                setVisible2(true);
                setFormData({
                  ...rowData,
                  uuid: rowData.uuid // Ensure UUID is explicitly set
                });
              }}
            >
              <i className="fa fa-pen"></i>
            </a>
          </PermissionGate>
          <PermissionGate permission="p_ad0004">
            <a
              className="delete"
              onClick={(e) => {
                deleteUser(rowData.uuid);
              }}
            >
              <i className="fa fa-trash"></i>
            </a>
          </PermissionGate>
        </div>
      </>
    );
  };

  const representativesItemTemplate = (option) => {
    
    return (
      <div className="flex align-items-center gap-2">
        <img
          alt={'pic'}
          src={`${process.env.REACT_APP_BASE_URL_IMG}${option.imagePath}`}
          className="ads-img"
        />
      </div>
    );
  };

  const urlAction = (rowData) => {
    return (
      <>
        <div className="action-table">
          <a
            href={`${rowData.linkUrl}`}
            target="_blank"
          >
            {rowData.linkUrl}
          </a>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="dev-table">
          <Navbar />
          <div className="table-card">
            <div className="table">
              <PermissionGate permission="p_ad0002">
                <a className="add" onClick={() => setVisible(true)}>
                  <i className="fa fa-plus"></i>
                </a>
              </PermissionGate>
              <GlobalDataTable
                ref={adsTableRef}
                fetchPage={fetchAdsPage}
                defaultRowCount={10}
                rowCountOptions={[10, 20, 50, 100]}
                searchPlaceholder="Search link, dates, image path…"
                emptyMessage="No advertisements found."
                headerTitle={
                  <span>
                    <i className="fa fa-bullhorn me-2"></i>
                    Advertisements
                  </span>
                }
                dataKey="uuid"
                showGridlines
                tableStyle={{ minWidth: "700px" }}
              >
                <Column
                  field="image"
                  body={representativesItemTemplate}
                  header="image"
                  style={{ width: "20%" }}
                ></Column>
                <Column
                  field="linkUrl"
                  header="link Url"
                  style={{ width: "20%" }}
                  body={urlAction}
                ></Column>
                <Column field="dateFrom" header="start Date" style={{ width: "20%" }}></Column>
                <Column field="dateTo" header="end Date" style={{ width: "20%" }}></Column>
                <Column field="uuid" header="" style={{ width: "20%" }} body={statusAction}></Column>
              </GlobalDataTable>
              <Dialog
                visible={visible}
                modal
                header={headerElement}
                footer={footerContent}
                style={{ width: "50rem" }}
                onHide={() => {
                  if (!visible) return;
                  setVisible(false);
                }}
              >
                <Form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Upload Image</Form.Label>
                        <Form.Control
                          id="ImageFile"
                          className="file"
                          type="file"
                          name="ImageFile"
                          placeholder="text"
                          onChange={handleFileChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Link Url</Form.Label>
                        <Form.Control
                          type="text"
                          name="linkUrl"
                          placeholder="linkUrl"
                          value={formData.linkUrl}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="dateFrom"
                          placeholder="Start Date"
                          value={formData.dateFrom}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="dateTo"
                          placeholder="End Date"
                          value={formData.dateTo}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Form>
              </Dialog>
              <Dialog
                visible={visible2}
                modal
                header={headerElement2}
                footer={footerContent2}
                style={{ width: "50rem" }}
                onHide={() => {
                  if (!visible2) return;
                  setVisible2(false);
                }}
              >
                <Form onSubmit={editUser}>
                  <input type="hidden" name="uuid" value={formData.uuid} />
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Upload Image</Form.Label>
                        <Form.Control
                          className="file"
                          type="file"
                          name="imagePath"
                          onChange={handleFileChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Link Url</Form.Label>
                        <Form.Control
                          type="text"
                          name="linkUrl"
                          placeholder="Link Url"
                          value={formData.linkUrl}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="dateFrom"
                          placeholder="01143987449"
                          value={formData.dateFrom}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="dateTo"
                          placeholder="01143987449"
                          value={formData.dateTo}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Form>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Adv;
